import AllInclusiveIcon from "@mui/icons-material/AllInclusive";
import { Box, Link, OverflowText, Text } from "designSystem/index";
import { STANDARD_BORDER_STYLE } from "designSystem/styles/style-functions";
import React from "react";
import CssColumnGrid from "designSystemLegacy/CssColumnGrid";

export default () => (
	<CssColumnGrid columns={2}>
		<Text semiBold text="flex" />
		<Text semiBold text="not flex" />
		<Box
			border={STANDARD_BORDER_STYLE}
			display="inline-flex"
			padding={2}
			width={200}
		>
			<Box mr={1}>
				<AllInclusiveIcon />
			</Box>
			<Link
				grow
				href="http://centricsoftware.com"
				target="_blank"
			>
				<OverflowText text="Centric Software sells award winning PLM!" />
			</Link>
		</Box>
		<Box
			border={STANDARD_BORDER_STYLE}
			display="inline-block"
			padding={2}
			width={200}
		>
			<Link
				fullWidth
				href="http://centricsoftware.com"
				target="_blank"
			>
				<OverflowText text="Centric Software sells award winning PLM!" />
			</Link>
		</Box>
	</CssColumnGrid>
);
